import React, { useContext } from "react";
import { AuthContext } from "../../context/authContext";
import SidebarComponent from "../../components/dashboard/Sidebar";
import Loader from "../../components/Loader";
import YieldLeaderboard from "../../components/dashboard/YieldLeaderboard";

const AllYields = () => {
  const { admin } = useContext(AuthContext);
  return (
    <div>
      <div>
        <Loader />
      </div>
      <div>
        <SidebarComponent user={admin} />
      </div>
      <div className="p-4 sm:ml-64 bg-[#0a0c0f]">
        <div className="p-4 border border-gray-600 border-dashed rounded-lg dark:border-gray-700 mt-20 min-h-screen">
          <div>
            <h1 className="text-gray-400 text-xl font-medium">All Yields</h1>
          </div>
          <div>
            <YieldLeaderboard />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllYields;
